import { render } from "./ContentStyles.vue?vue&type=template&id=63395efb&scoped=true"
import script from "./ContentStyles.vue?vue&type=script&lang=js"
export * from "./ContentStyles.vue?vue&type=script&lang=js"

import "./ContentStyles.vue?vue&type=style&index=0&id=63395efb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63395efb"]])

export default __exports__